import * as _ from 'underscore';
import { DataMap } from './dataMap';
import { Util, FilterUtil } from '..';
import { FilterOptions, FilteringDataMapOptions } from '../../interfaces/options';
import { DefaultFilteringDataMapOptions } from '../../const/defaultOptions';

export class FilteringDataMap<T> extends DataMap<T> {
	public filterSettings: KnockoutObservableArray<FilterOptions>;
	public isFilterOn: KnockoutComputed<boolean>;
	constructor(
		data: KnockoutObservableArray<T> | KnockoutComputed<T[]> | KnockoutObservable<T[]> | DataMap<T>,
		options: FilteringDataMapOptions<T>
	) {
		super(data);
		options = _.defaults({}, options, DefaultFilteringDataMapOptions);
		this.filterSettings = ko.observableArray<FilterOptions>();
		this.isFilterOn = ko.pureComputed(() => this.filterSettings().length > 0);
		this.map = ko.pureComputed(() => {
			var data: Array<T> = this.data(),
				filterSettings =
					options.prefilter && options.prefilter.length > 0
						? options.prefilter.concat(this.filterSettings())
						: this.filterSettings();
			if (filterSettings && filterSettings.length > 0 && data && data.length > 0) {
				return data.filter((item: T, index: number, array: T[]) => {
					return (
						options.bypass(item) ||
						_.every(filterSettings, (filter: FilterOptions) => {
							return FilterUtil.func[filter.operator].call(
								this,
								Util.getProperty(item, filter.key),
								filter.params,
								filter.stringComparer
							);
						})
					);
				});
			} else {
				return data;
			}
		});
	}
	public filter(filterSettings: FilterOptions[]) {
		this.filterSettings(filterSettings);
	}
}
